import update from 'immutability-helper';
import { AnyAction, Dispatch } from 'redux';

import { loadReasonTypes as doReasonTypes } from '../services/reasonTypes';

// Actions
const START_LOAD = 'vendors/reasonTypes/START_LOAD';
const COMPLETE_LOAD = 'vendors/reasonTypes/COMPLETE_LOAD';
const FAIL_LOAD = 'vendors/reasonTypes/FAIL_LOAD';
const RESET = 'vendors/reasonTypes/RESET';

// Initial state
const initialState = {
  isLoading: false,
  isSaving: false,
  reasonTypes: undefined,
};

// Reducer
export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          reasonTypes: action.reasonTypes,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
        },
      });

    case RESET:
      return update(state, { $merge: initialState });

    default:
      return state;
  }
};

// Action creators
const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (reasonTypes: any) => ({
  type: COMPLETE_LOAD,
  reasonTypes,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

export const loadReasonTypes = (vendorId: number, vehicleTypeId: number) => (dispatch: Dispatch) => {
  dispatch(startLoad());
  const loadReasonTypesPromise = doReasonTypes(vendorId, vehicleTypeId);
  loadReasonTypesPromise
    .then(notificationTypes => dispatch(completeLoad(notificationTypes)))
    .catch(() => dispatch(failLoad()));

  return loadReasonTypesPromise;
};

export const resetReasonTypes = () => ({
  type: RESET,
});
